import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code"]

  copy(event) {
    const code = this.codeTarget.textContent.trim()
    navigator.clipboard.writeText(code)
      .then(() => {
        console.log("Code copied:", code)
        alert("Secret key copied to clipboard!")
      })
      .catch((error) => {
        console.error("Clipboard copy failed", error)
        alert("Failed to copy secret key.")
      })
  }
}
